<template>
  <div>
    <div id="home" v-loading="loading">
      <img class="img" src="../assets/imgs/edit.png"/>
      <h1>거의 다 되었습니다!</h1>
      <p>
        정확한 퇴직금 신청을 위해 신청자 정보를<br/>정확하게 입력해주세요
      </p>
      <div class="nameRow">
        <el-input style="width: 100%;" placeholder="이름" type="text" v-model="name"></el-input>
        <span v-if="initNameIsHave">
          <i class="el-icon-success"></i>
          카카오 인증완료
        </span>
      </div>

      <div v-if="!!kakaoPhone" class="phoneExist">
        {{kakaoPhone}}
        <span>
          <i class="el-icon-success"></i>
          카카오 인증완료
        </span>
      </div>
      <el-input
        v-else
        style="width: 100%;margin-top: 10px;"
        v-model="phone"
        :editable="false"
        :clearable="false"
        @input="phoneInput"
        maxlength="13"
        placeholder="전화번호"
        type="tel">
      </el-input>
      <div class="error" v-if="errInput !== ''">
        <i class="el-icon-warning"></i>
        {{errInput}}
      </div>
      <div class="content">
        <h1>
          필수 동의
        </h1>
        <div class="list">
          <div class="item">
            <i :class="agree1 ? 'el-icon-success' : 'el-icon-circle-check'" @click="agree1 = !agree1"></i>
            [필수] 서비스 이용 및 상담을 위한 필수 동의
          </div>
          <div class="item">
            <i :class="agree2 ? 'el-icon-success' : 'el-icon-circle-check'" @click="agree2 = !agree2"></i>
            [필수] 전자계약 서명 및 법적 효력 동의
          </div>
          <div class="item">
            <i :class="agree3 ? 'el-icon-success' : 'el-icon-circle-check'" @click="agree3 = !agree3"></i>
            [필수] 작성자 본인 확인 및 법적 책임 동의
          </div>
        </div>
      </div>
      <div class="btn" :class="{btnAct:validateBtn}" @click="submit">
        다음
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import moment from 'moment/moment';
  import { postAction } from '@/network/manage';
  import { signMethod } from '@/utils/sign';
  export default {
    name: 'PhoneValidate',
    data() {
      return {
        loading:false,
        name: '',
        kakaoPhone:'',
        phone:'',
        errInput:'',
        agree1: false,
        agree2: false,
        agree3: false,
        initNameIsHave: false
      }
    },
    computed: {
      validatePhone() {
        return /^01[016789]-\d{4}-\d{4}$/.test(this.phone)
      },
      validateBtn() {
        return !!this.name && (!!this.kakaoPhone || this.validatePhone) && this.agree1 && this.agree2 && this.agree3
      }
    },
    created() {
     if(Vue.ls.get('joinDate') && Vue.ls.get('leaveDate') && Vue.ls.get('salary') && Vue.ls.get('money')){
       let kakaoPhone = Vue.ls.get('kakaoPhone')
       if (!!kakaoPhone) {
         kakaoPhone = kakaoPhone.replace(/-/g, '')
         this.kakaoPhone = `${kakaoPhone.slice(0, 3)}-${kakaoPhone.slice(3, 7)}-${kakaoPhone.slice(7)}`
       }
       this.name = (!!Vue.ls.get('name'))?Vue.ls.get('name'):""
       if(this.name != "") {
         this.initNameIsHave = true
       }
     } else {
       this.$router.push('/home')
     }
    },
    methods:{
      phoneInput() {
        let value = this.phone;
        const digits = value.replace(/-/g, '')

        if (digits.length >= 4 && digits.length <= 7) {
          if (!value.startsWith(digits.slice(0, 3) + '-', 0)) {
            value = digits.slice(0, 3) + '-' + digits.slice(3)
          }
        }

        if (digits.length >= 8) {
          const firstPart = digits.slice(0, 3) + '-' + digits.slice(3, 7)
          if (!value.includes(firstPart + '-')) {
            value = firstPart + '-' + digits.slice(7, 11)
          }
        }
        this.phone = value
      },
      async submit() {
        if (!this.name) {
          this.$message.error('이름을 입력해주세요.')
          return
        }
        if (!this.kakaoPhone && !this.validatePhone) {
          this.$message.error('올바른 휴대폰 번호를 입력해주세요.')
          return
        }
        if (!this.agree1 || !this.agree2 || !this.agree3) {
          this.$message.error('모든 약관에 동의해주세요.')
          return
        }
        const timestampMs = Date.now();
        const params = {
          name: this.name,
          phoneNumber: this.kakaoPhone || this.phone,
          email: Vue.ls.get('email'),
          nickname: Vue.ls.get('nickname'),
          joiningDate: moment(Vue.ls.get('joinDate')).format('YYYY-MM-DD'),
          departureDate: moment(Vue.ls.get('leaveDate')).format('YYYY-MM-DD'),
          totalPayroll: Vue.ls.get('salary'),
          timestamp: timestampMs,
          sign: signMethod((this.kakaoPhone || this.phone), this.name, timestampMs)
        }
        this.loading = true
        const res = await postAction('/app/applicationRecord/addRecord', params)
        this.loading = false
        if(res.success) {
          Vue.ls.remove('kakaoPhone')
          Vue.ls.remove('email')
          Vue.ls.remove('nickname')
          Vue.ls.remove('joinDate')
          Vue.ls.remove('leaveDate')
          Vue.ls.remove('salary')
          this.$router.push('/phoneResult')
        }else{
          this.$message.error(res.message)
        }
      },
    }
  }
</script>

<style scoped>
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home{height: 100vh;display: flex;flex-direction: column;width: 100%;padding:20px;}
  h1{color:#333333;font-size: 22px;margin:20px 0 10px 0;}
  p{color: #717B85;margin-bottom: 20px;}
  .img{height: 64px;width: 64px;}
  .nameRow{border:1px solid #D8DEE4;border-radius: 4px;margin-top: 10px;padding:0 16px;color:#111111;font-size:14px;display: flex;justify-content: space-between;align-items: center;}
  .nameRow span{color:#009F7A;display: flex;align-items: center;flex-shrink: 0;}
  .nameRow span i{font-size: 18px;margin-right: 6px;}
  >>> .nameRow .el-input__inner{border:none !important;padding-left: 0;}
  .phoneExist{background-color: #F4F6FB;border:1px solid #D8DEE4;height: 50px;border-radius: 4px;margin-top: 10px;padding:0 16px;color:#111111;font-size:14px;display: flex;justify-content: space-between;align-items: center;}
  .phoneExist span{color:#009F7A;display: flex;align-items: center;}
  .phoneExist span i{font-size: 18px;margin-right: 6px;}
  .el-icon-success{color: #4873FF !important;}
  .btn{background:#EBECF0;color:#A8A8BC;display: flex;justify-content: center;margin-top:30px;align-items: center;width: calc(100vw - 40px);height: 52px;border-radius: 26px;font-weight: bold;}
  .btnAct{background:#4873FF !important;color:#ffffff !important;}
  .errInput >>> .el-input__inner {background-color: #FFF3F3;border-color: #F20000;}
  .error{display: flex;align-items: center;color: #EC0000;font-size: 14px;margin-top: 10px;}
  .error i{margin-right: 5px;font-size: 18px;}
  .content{background-color: #ffffff;margin-top:40px;display: grid;grid-template-columns: 1fr;gap:20px;width: 100%;}
  .content h1{margin:0;font-size: 20px;}
  .content .list{display: grid;grid-template-columns: 1fr;gap:20px;}
  .content .list .item{color: #717B85;font-size: 14px;display: flex;align-items: center;}
  .content .list .item i{font-size: 24px;margin-right: 10px;color: #CCD3E5;}
</style>
